/**
 * Sticky Add to Cart (mobile only).
 *
 * Submits the SAME product form as the real button (via the `form`
 * attribute) — no cart logic is duplicated here, Shopify's own
 * product-form.js handles the actual AJAX add-to-cart exactly as it
 * would for the in-page button. This script only handles: showing the
 * bar once the real button scrolls out of view, and mirroring the
 * price/disabled state so the two buttons never disagree.
 */
(function () {
  if (window.matchMedia('(min-width: 750px)').matches) return;

  function init(bar) {
    const watchId = bar.dataset.watch;
    const watchTarget = watchId && document.getElementById(watchId);
    if (!watchTarget) return;

    const stickyButton = bar.querySelector('.sticky-add-to-cart__button');
    const priceMirror = bar.querySelector('[data-mirror-price]');
    const priceSourceId = priceMirror && priceMirror.dataset.mirrorPrice;
    const priceSource = priceSourceId && document.getElementById(priceSourceId);

    // Show the bar only once the real button has scrolled above the
    // viewport (not simply "not yet visible" on initial load).
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
        });
      },
      { threshold: 0 }
    );
    observer.observe(watchTarget);

    // Keep the disabled state (sold out / unavailable variant) in sync.
    if (stickyButton) {
      const syncDisabled = () => {
        stickyButton.disabled = watchTarget.disabled;
      };
      syncDisabled();
      new MutationObserver(syncDisabled).observe(watchTarget, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }

    // Keep the displayed price in sync with variant selection.
    if (priceMirror && priceSource) {
      const syncPrice = () => {
        // Prefer the sale price when present; `.price-item--regular` is
        // reused for the struck-through original price too (as an <s>
        // tag), so it must lose to an actual sale price if one exists.
        const amount =
          priceSource.querySelector('.price-item--sale') ||
          priceSource.querySelector('span.price-item--regular') ||
          priceSource.querySelector('.price-item');
        if (amount && amount.textContent.trim()) {
          priceMirror.textContent = amount.textContent.trim();
        }
      };
      syncPrice();
      new MutationObserver(syncPrice).observe(priceSource, { childList: true, subtree: true, characterData: true });
    }

    // Guard against double submissions while the real form's AJAX
    // request is in flight — Dawn's own loading state only decorates
    // the in-page button, since this one lives outside <product-form>.
    if (stickyButton) {
      const form = stickyButton.form;
      if (form) {
        form.addEventListener('submit', () => {
          if (stickyButton.disabled) return;
          stickyButton.classList.add('is-loading');
          stickyButton.disabled = true;
          window.setTimeout(() => {
            stickyButton.classList.remove('is-loading');
            stickyButton.disabled = watchTarget.disabled;
          }, 2000);
        });
      }
    }
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-sticky-add-to-cart]:not([data-initialized])').forEach((bar) => {
      bar.setAttribute('data-initialized', 'true');
      init(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  }
})();
